import React from 'react';
import { GenerationReport } from './components/GenerationReport/GenerationReport';
import { useAppSelector } from '@shared/model';
import { EmailSendingSection } from './components/EmailSendingSection';
import { selectIsGenerationReportShown } from '@pages/invoice-generator/shared/model/reportsSection.selectors';
import classes from './ExecutionReportsSection.tailwind';
import { selectGeneratedSuccessfullyCount, selectGeneratedTotal } from '@entities/generation-state';

export const ExecutionReportsSection = () => {
  const isGenerationReportShown = useAppSelector(selectIsGenerationReportShown);
  const generatedTotal = useAppSelector(selectGeneratedTotal);
  const generatedSuccessfully = useAppSelector(selectGeneratedSuccessfullyCount);

  const isSendingAllowed = generatedSuccessfully > 0 && generatedTotal === generatedSuccessfully;

  if (isGenerationReportShown) {
    return (
      <div className={classes.sectionContainer} data-id="reports-section">
        <GenerationReport />

        {isSendingAllowed && <EmailSendingSection />}
      </div>
    );
  }

  return null;
};
